import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import {
  Message,
  TreeNode,
  SelectItem,
  ConfirmationService,
  ConfirmEventType,
} from 'primeng/api';
import { Table } from 'primeng/table';
import {
  link,
  breadcrumb,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import icons from '../../../../misc/data/icons.json';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { GlobalConstants } from 'src/app/services/global-constants';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-survey-tags-management',
  templateUrl: './survey-tags-management.component.html',
  styleUrls: ['./survey-tags-management.component.scss']
})
export class SurveyTagsManagementComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  @ViewChild('dt')
  dt!: Table;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];

  treedata: TreeNode[] = [];
  header = this.translate('Tags');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-chevron-circle-right',
      link: '/survey',
      visible: this.permissionService.hasPermission('SURVEY', 'r')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Polls'), link: '/survey' },
    { name: this.translate('Tags'), link: '/survey/tags-management' },
  ];
  stats: stat[] = [];

  categoryData: any[] = [];
  isAssessment: boolean = false;
  isSurvey: boolean = false;
  isMS: boolean = false;
  tableUnit: string = '';
  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  deleteModal: boolean = false;
  deleteData: any;

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;
  transferData: boolean = true;
  changeCategory: any;
  deleteMessage: any = [];
  ous: TreeNode[] = [];
  ous_original: TreeNode[] = [];
  staticURL = GlobalConstants.staticFilesURL;
  readonly DESIGNATION_ORG_TYPE_ID = '6469296b87f9e1cc8aa233c6';

  constructor(
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private ouService: OrgUnitsService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.isAssessment = (params['from'] == 'assessment');
      this.isSurvey = (params['from'] == 'survey');
      this.isMS = (params['from'] == 'ms');
      if (this.isAssessment)
      {
        this.tableUnit = 'ASSESSMENT_TAGS';
      } else if(this.isSurvey) {
        this.tableUnit = 'SURVEY_TAGS';
      }
      else if(this.isMS){
        this.tableUnit = 'MYSTERY_SHOPPER_TAGS'
      }
      
      if (params['from']) {
        this.getTags().then((e: any) => {
          this.skelition = false;
        });
        this.makequestion();
      } else {
        this.location.back()
      }

      let backURL = '';
      if (this.isAssessment)
      {
        backURL = 'assessment';
      } else if(this.isSurvey) {
        backURL = 'survey';
      }
      else if(this.isMS){
        backURL = 'ms/project';
      }
      this.links[0].link = `/${backURL}`
      this.breadcrumbs[0] = { name: this.translate(this.ucfirst(params['from'])), link: `/${backURL}` };
      this.breadcrumbs[1] = { name: this.translate('Tags'), link: '/' + params['from'] + '/tags-management' };
    });

    this.ouService.getOrgUnits().then((res: any) => {
      this.ous_original = res;
      // Show Ministries/Entities, Branches, and Departments when creating a tag
      this.filterTreeByTag(['Ministries/Entities', 'Organisational Structure', 'Branches']);
      this.makequestion();
    });

    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });
    
  }

  // Add New Interface

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  ucfirst(text: string): string {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'arabic',
        label: this.translate('the name'),
        required: true,
        order: 1,
        className: 'col-md-12 col-sm-12 col-12',
      }),
      new TreeSelectQuestion({
        key: 'ou',
        label: this.translate('Organizational Unit'),
        required: false,
        treeOptions: this.ous,
        order: 2,
        className: 'col-md-12 col-sm-12 col-12',
        filter: true
      })
    ];
  }



  addTag = async ($event: any) => {
    try {
      let data = $event;
      if (this.isAssessment)
      {
        data.type = 'ASSESSMENT';
      } else if(this.isSurvey) {
        data.type = 'SURVEY';
      }
      else if(this.isMS){
        data.type = 'MS';
      }

      if (data.ou && data.ou._id) {
        data.ou = data.ou._id;
      } else {
        delete data.ou;
      }

      let res = await this.dataService.postData(
        'survey-tags',
        data
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      this.getTags();
    } catch (error) {
      console.log(error);
    }
  };

  hasCreatePermission() {
    if (this.isAssessment)
    {
      return this.permissionService.hasPermission('ASSESSMENT_TAGS', 'c')
    } else if(this.isSurvey) {
      return this.permissionService.hasPermission('SURVEY_TAGS', 'c')
    }
    else if(this.isMS){
      return this.permissionService.hasPermission('MYSTERY_SHOPPER_TAGS', 'c')
    }
    return false;
  }

  updateCategory = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;

      if (data.ou && data.ou._id) {
        data.ou = data.ou._id;
      } else {
        data.ou = null;
      }

      let res = await this.dataService.postData(
        `survey-tags`,
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      this.getTags();
    } catch (error) {
      console.log(error);
    }
  };

  // Add Table Configuration
  getTags = async () => {
    this.skelition = true;
    this.data = [];
    let type = '';
    if (this.isAssessment)
    {
      type = 'ASSESSMENT';
    } else if(this.isSurvey) {
      type = 'SURVEY';
    }
    else if(this.isMS){
      type = 'MS';
    }

    try {
      let res = await this.dataService.getData(`survey-tags/${type}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.categoryData = res.data;
      this.data = this.categoryData.map(item => {
        let obj: any = {
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'الاسم': { n: item.arabic },
          'الوحدة التنظيمية': { n: item.ou ? item.ou.name : 'All' }
        };
        if (this.isAssessment) {
          obj[this.translate('Question Bank Heading')] = { n: item.questionbank_names };
        }
        obj.Action = [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ];
        if (this.isAssessment) {
          if (item.questionbanks.length > 0) {
            obj.Action = [{
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            }]
          }
        }

        if (item._id == "656402d3d14df32354c60e61" || item._id == "66924a245f74032cf67cf11d" || item._id == "66f2c88e788bfe7c2ebd80e2")
          {
            obj.Action = [{
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            }]
          }
        console.log("item.tag",item.tag);
        if (item.tag == 'MASTER_TAG') {
          obj.Action = [{
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          }]
        } else if (item.tag == 'GENERAL_QB') {
          obj.Action = [{
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          }]
        }
        return obj;
      })
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteTag($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.categoryData.find(
          (item) => item._id == $event.id
        );
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'arabic',
            label: this.translate('the name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.arabic,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new TreeSelectQuestion({
            key: 'ou',
            label: this.translate('Organizational Unit'),
            required: false,
            treeOptions: this.ous,
            order: 2,
            className: 'col-md-12 col-sm-12 col-12',
            filter: true,
            selectionMode: 'single',
            value: this.updateData.ou ? this.ouService.findBy_Id(this.ous, this.updateData.ou._id) : null
          }),

          new TextboxQuestion({
            key: 'Tag',
            label: this.translate('Tag'),
            required: false,
            order: 3,
            icon: 'pi pi-file',
            value: this.updateData.tag,
            disable: true,
            visibility: 'false',
            className: 'col-md-12 col-sm-12 col-12',
          }),
        ];
        // console.log("Update Data ==>",this.categoryData,this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteTag = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(
        `survey-tags/${id}`,
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error') },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.getTags();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  filterTreeByTag(tags: string[]) {
    this.ous = cloneDeep(this.ous_original);
    this.ous = this.ous
      .map((node: any) => this.filterNodes(node, tags))
      .filter((filteredNode: any) => filteredNode !== null);
  }

  filterNodes(node: any, tags: string[]): any | null {
    // Exclude designations (identified by org-type)
    if (node.orgTypeId === this.DESIGNATION_ORG_TYPE_ID) {
      return null;
    }
    
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tags))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    if (tags.includes(node.tag) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null;
  }

}
